// screens/HomeScreen.jsx
import React from 'react';
import HeroSection from '../components/home/HeroSection';
import QuickActions from '../components/home/QuickActions';
import ServicesOverview from '../components/home/ServicesOverview';
import Departments from '../components/home/Departments';
import Doctors from '../components/home/Doctors';
import Announcements from '../components/home/Announcements';
import WhyChooseUs from '../components/home/WhyChooseUs';

const HomeScreen = () => {
    return (
        <div className="w-full">
            {/* Hero Section */}
            <HeroSection />
            
            {/* Quick Actions */}
            <QuickActions />
            
            {/* Services Overview */}
            <ServicesOverview />
            
            {/* Departments */}
            <Departments />
            
            {/* Doctors */}
            <Doctors />
            
            {/* Announcements */}
            <Announcements />
            
            {/* Why Choose Us */}
            <WhyChooseUs />
        </div>
    );
};

export default HomeScreen;